import React from "react";

import { Text } from "src/components";

export default ({
  children,
  hasLeftIcon,
  fontSize = 1,
  position = {
    position: "absolute",
    top: 5,
    left: hasLeftIcon ? 64 : 34,
  },
  ...styles
}) => (
  <Text fontSize={fontSize} color="blue" {...position} {...styles}>
    {children}
  </Text>
);



// WEBPACK FOOTER //
// ./src/components/Form/FloatingLabel.js